(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomUserDetailController', CustomUserDetailController);

    CustomUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomUser', 'User', 'ProfessionalArea', 'Answer', 'Comment', 'Task', 'FrequentlyAskedQuestion'];

    function CustomUserDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomUser, User, ProfessionalArea, Answer, Comment, Task, FrequentlyAskedQuestion) {
        var vm = this;

        vm.customUser = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:customUserUpdate', function(event, result) {
            vm.customUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
